import React from 'react';
import { ValidationOptions } from 'react-hook-form/dist/types';
import { OutlinedTextFieldProps } from '@mui/material/TextField/TextField';
import { RegisteredMuiInput } from 'components/base/mui-custom-input/RegisteredMuiInput';

import './input-box.styles.scss';

interface IInputBox extends Partial<OutlinedTextFieldProps> {
	title: string;
	name: string;
	validation?: ValidationOptions;
	value?: string;
}

export const InputBox = ({ title, label, name, ...props }: IInputBox) => {
	return (
		<div className="input-box">
			<h3 className="input-box__title">{title}</h3>
			<RegisteredMuiInput label={label} name={name} {...props} />
		</div>
	);
};
